module.exports = __webpack_public_path__ + "static/media/product-placeholder.44ae209c.png";